
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'teszt',
	'visualizationSlideoutTitle': 'Megjelenítések',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Adjon meg egy számot',
	'maxValuePlaceholder': 'Adjon meg egy számot',
	'customRangeErrorMessage': 'Az érték csak szám lehet',
	'propFillColor': 'Kitöltés színe',
	'propBorderColor': 'Szegélyszín',
	'propColorPalette': 'Aktuális színpaletta',
	'propColorPaletteChangeLabel': 'Színpaletta módosítása',
	'propNewColorPaletteLabel': 'Egyéni színpaletta létrehozása',
	'propNewHeatPaletteLabel': 'Egyéni hőpaletta létrehozása',
	'propDonutRadius': 'Fánk sugara',
	'showTitleLabel': 'Cím megjelenítése',
	'titleTypeLabel': 'Cím típusa',
	'smartTitleLabel': 'Intelligens cím',
	'customTitleLabel': 'Egyéni cím',
	'noTitleLabel': 'Nincs cím',
	'propHeatScalePalette': 'Aktuális hőpaletta',
	'propHeatPaletteChangeLabel': 'Hőpaletta módosítása',
	'propMaintainAxisScales': 'Tengelylépték megtartása',
	'propLineAndSymbolColor': 'Vonal és szimbólum színe',
	'propLineAndSymbolPalette': 'Vonal és szimbólum színpaletta',
	'propElementColor': 'Elem színe',
	'propColumnColor': 'Oszlop színe',
	'propColumnPalette': 'Oszlop színpalettája',
	'propColumnHeatPalette': 'Oszlop hőpaletta',
	'propBarColor': 'Sáv színe',
	'propGoalColor': 'Cél színe',
	'propToColor': 'Színre',
	'propFromColor': 'Színről',
	'propNumberValidationErrorMessageId': 'Adjon meg egy számot',
	'fontSizeAuto': 'Automatikus',
	'propAutoBinCount': 'Csoportok száma',
	'propAutoBinToggle': 'Automatikus csoportosítás',
	'tabName_general': 'Általános',
	'tabName_visDetails': 'Részletek',
	'tabName_animation': 'Animáció',
	'tabName_mediaDetails': 'Médiatartalom részletei',
	'tabName_webDetails': 'Weblap részletei',
	'tabName_imageDetails': 'Kép részletei',
	'tabName_visualization': 'Megjelenítés',
	'tabName_text': 'Szöveg',
	'sectionName_colorsAndThemes': 'Szín és témák',
	'sectionName_appearance': 'Megjelenés',
	'sectionName_general': 'Általános',
	'sectionName_colorPalette': 'Szín',
	'sectionName_axis': 'Tengely',
	'sectionName_axis_label': 'Tengely',
	'sectionName_legend': 'Jelmagyarázat',
	'sectionName_chart': 'Diagram',
	'sectionName_regionLayer': 'Régiók réteg',
	'sectionName_pointLayer': 'Pontok réteg',
	'sectionName_latLongLayer': 'Földrajzi szélesség/földrajzi hosszúság réteg',
	'sectionName_pathLayer': 'Útvonalréteg',
	'sectionName_xAxis': 'X tengely',
	'sectionName_yAxis': 'Y tengely',
	'sectionName_xAxis_title': 'X tengely címe',
	'sectionName_yAxis_title': 'Y tengely címe',
	'sectionName_xAxis_label': 'X tengely címkéje',
	'sectionName_yAxis_label': 'Y tengely címkéje',
	'sectionName_column_yAxis': 'Oszlop Y tengelye',
	'sectionName_column_yAxis_label': 'Oszlop Y tengely címkéje',
	'sectionName_column_yAxis_title': 'Oszlop Y tengely címe',
	'sectionName_line_yAxis': 'Sor Y tengelye',
	'sectionName_line_yAxis_label': 'Sor Y tengely címkéje',
	'sectionName_line_yAxis_title': 'Sor Y tengely címe',
	'sectionName_title': 'Cím',
	'sectionName_dataValueLabels': 'Adatok értékcímkéi',
	'sectionName_style': 'Stílus',
	'propTransparencyDescription': 'Az átlátszóság növelése vagy csökkentése. Adjon meg egy 0 és 100 közötti értéket',
	'smart_annotation_unauthorized': 'Jegyzetek: jogosulatlan hozzáférés',
	'smart_annotation_method': 'Jegyzetek: a metódus nem engedélyezett',
	'smart_annotation_media': 'Jegyzetek: az adathordozó típusa nem engedélyezett',
	'smart_annotation_input': 'Jegyzetek: a bemenet érvénytelen',
	'smart_annotation_internal': 'Jegyzetek: belső rendszerhiba',
	'smart_annotation_generic_error': 'Jegyzetek: szolgáltatáshiba',
	'smart_annotation_dialog_title': 'Betekintések',
	'smart_annotation_Show_Insights': 'Insights megjelenítése',
	'smart_annotation_Relationship': 'A kapcsolat',
	'forecast_enter_number': 'Adjon meg egy, a következők közé eső számot ',
	'and': ' és ',
	'smart_errors': 'Szövegmagyarázat hibák:',
	'smart_warnings': 'Szövegmagyarázat figyelmeztetések:',
	'smart_annotation_insight_icon_title': 'Betekintések',
	'smart_annotations_toggle_on': 'Insights bekapcsolása',
	'smart_annotations_toggle_off': 'Insights kikapcsolása',
	'smart_annotation_toggle_on': 'Váltókapcsoló bekapcsolva',
	'smart_annotation_toggle_off': 'Váltókapcsoló kikapcsolva',
	'smart_annotation_insight_unavailable': 'A betekintések jelenleg nem elérhetők',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Első vagy utolsó % szűrő alkalmazása esetén nem állnak rendelkezésre betekintések',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Első vagy utolsó % szűrő alkalmazása esetén nem áll rendelkezésre előrejelzés',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Első vagy utolsó szűrő alkalmazása esetén, illetve ha a mezőben egynél több oszlop van, nem állnak rendelkezésre betekintések',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Első vagy utolsó szűrő alkalmazása esetén, illetve ha a mezőben egynél több oszlop van, nem áll rendelkezésre előrejelzés',
	'forecast_title': 'Előrejelzés',
	'forecast_show': 'Előrejelzés megjelenítése',
	'forecast_toggle_on': 'Előrejelzés bekapcsolása',
	'forecast_toggle_off': 'Előrejelzés kikapcsolása',
	'statDetailsPerspectiveTitle': 'Elemzés',
	'emptyStatDetailsPanel': 'Az aktuális megjelenítéshez nem áll rendelkezésre további elemzés.',
	'predict_errors': 'Elemzési hibák',
	'predict_warnings': 'Elemzés figyelmeztetései',
	'fpd_invalid_data_source': 'Ez az adatforrás nem rendelkezik társított intelligens modullal',
	'fpd_network_issue': 'Probléma merült fel az futtatásakor ezen az adatforráson',
	'fpd_data_source_category': 'Az intelligens modul hiányzik',
	'fpd_response_errors': 'Javasolt tényező hibái',
	'fpd_response_warnings': 'Javasolt tényező figyelmeztetései',
	'catalyst_service_bad_request': 'Helytelen kérés',
	'catalyst_service_unkown_Id': 'Ismeretlen kérésazonosító található',
	'catalyst_service_internal_server_error': 'Belső kiszolgáló hiba',
	'catalyst_service_generic_error': 'Catalyst szolgáltatás hiba',
	'catalyst_service_error': 'Ez a szolgáltatás jelenleg nem áll rendelkezésre',
	'propLegendPosition': 'Jelmagyarázat pozíciója',
	'propLeft': 'Bal',
	'propRight': 'Jobb',
	'propTop': 'Felső',
	'propBottom': 'Alsó',
	'propNone': 'Nincs',
	'propLegendDisplay': 'Jelmagyarázat megjelenítése',
	'targetThicknessPlaceHolder': '%{min} - %{max}',
	'targetThicknessErrorMsg': 'Adjon meg egy egész számot %{min} és %{max} között.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Tényezők (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'kijelölt)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Visszaállítás az alapértelmezett értékekre',
	'possibelKeyDriver_AddNewDrivers': 'További tényezők hozzáadása',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'További tényezők hozzáadása kereséssel',
	'possibleKeyDrivers_MaxPossibleReached': 'Néhány hozzáadandó tényező kijelölésének megszüntetése vagy mások kijelölése',
	'possibleKeyDrivers_Recommended': 'Javasolt',
	'visRecommendedTypes': 'Javasolt megjelenítési típusok',
	'visRecommender_smartsfailure': 'A megjelenítési ajánlások jelenleg nem érhetők el',
	'visMore': 'További...',
	'visMoreTooltip': 'További megjelenítések',
	'visOtherTypes': 'Egyéb megjelenítési típusok',
	'visChange': 'Megjelenítés módosítása',
	'automaticTypeCaption': 'Automatikus',
	'propVisType': 'Megjelenítési típusok',
	'dlg_loading': 'Betöltés...',
	'snippetListChartCaption': 'Kódrészlet lista',
	'convoClusterChartCaption': 'Párbeszédfürt',
	'areaChartCaption': 'Terület',
	'barChartCaption': 'Sáv',
	'columnChartCaption': 'Oszlop',
	'stackedbarChartCaption': 'Halmozott sáv',
	'stackedcolumnChartCaption': 'Halmozott oszlop',
	'bubbleChartCaption': 'Buborék',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Tényezőelemzés',
	'scatterChartCaption': 'Szórás',
	'lineChartCaption': 'Vonal',
	'pointChartCaption': 'Pont',
	'heatChartCaption': 'Hőtérkép',
	'bulletChartCaption': 'Felsorolásjel',
	'waterfallChartCaption': 'Vízesés',
	'radarChartCaption': 'Sugár',
	'boxplotChartCaption': 'Dobozdiagram',
	'pieChartCaption': 'Torta',
	'mapChartCaption': 'Térkép',
	'radialBarChartCaption': 'Radiális',
	'compositeChartCaption': 'Vonal és oszlop',
	'wordCloudChartCaption': 'Szófelhő',
	'networkChartCaption': 'Hálózat',
	'relationshipNetworkChartCaption': 'Viszonyhálózat',
	'treemapChartCaption': 'Fatérkép',
	'packedBubbleChartCaption': 'Zárt buborék',
	'hierarcicalPackedBubbleChartCaption': 'Hierarchia buborék',
	'spiralChartCaption': 'Spirál',
	'decisionTreeChartCaption': 'Döntési fa',
	'legacyMapChartCaption': 'Örökölt térkép',
	'sunburstChartCaption': 'Napsugár',
	'visUsageComparison': 'Összehasonlítás',
	'visUsageRelationships': 'Kapcsolatok',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Részek - egész',
	'visUsageGeospatial': 'Térinformatikai',
	'visUsageAdvanced': 'Speciális elemzések',
	'visUsageTablesAndSummary': 'Táblák és összegzés',
	'visUsageSocialInsights': 'Közösségi betekintések',
	'visUsageOther': 'Egyéb',
	'autoBinActionText': 'Automatikus csoportosítás',
	'filterAutobinActionText': 'Tároló szűrése',
	'memberCalculationActionText': 'Tag számítás',
	'toolbarActionCalculation': 'Számítás létrehozása',
	'toolbarActionEditCalculation': 'Számítás szerkesztése',
	'topBottomRankLabel': 'Rang (%{label})',
	'toolbarDeleteFilterActionText': 'Szűrő eltávolítása',
	'toolbarActionTopKeyDrivers': 'Tényezők megjelenítése',
	'toolbarActionCustomGroup': 'Egyéni csoport',
	'canNotCreateCustomGroup': 'Ez az egyéni csoport nem hozható létre.',
	'aria_label_datatable': 'Adattábla',
	'summaryCaption': 'Összegzés',
	'MeasuresCaption': 'Mérőszámok',
	'MeasuresGroupCaption': 'Mérőszámcsoport (%{count})',
	'ValuesCaption': 'Értékek',
	'turnInsightsOn': 'Insights bekapcsolása',
	'turnInsightsOff': 'Insights kikapcsolása',
	'decisionRules': 'Szabályok',
	'decisionTree': 'Fadiagram',
	'decisionSunburst': 'Fa napsugár',
	'switchToDecisionRules': 'Váltás döntési szabályokra',
	'switchToDecisionTree': 'Váltás döntési fára',
	'data_group_less_then': 'kevesebb, mint %{rangeTo}',
	'data_group_to': '%{rangeFrom} - < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} és felette',
	'nullValueContent': '(nincs érték)',
	'sum': 'Összeg',
	'count': 'Darabszám',
	'countdistinct': 'Egyedi darabszám',
	'avg': 'Átlag',
	'min': 'Minimális',
	'max': 'Maximális',
	'automatic': 'Egyéni',
	'variance': 'Variancia',
	'stddev': 'Szórás',
	'median': 'Medián',
	'calculated': 'Számított',
	'none': 'Nincs',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Adatkérési értékek',
	'inputLabelPrompt': 'Érték',
	'inputPlaceholderPrompt': 'Adjon meg értéket',
	'inputInvalidText': 'Érvénytelen adatbevitel az %{dataType} típus esetén',
	'unSupportedPrompt': 'Nem támogatott adatkérés',
	'missingDataSource': 'Nem található a megfelelő adatforrás.',
	'unSupportedPromptType': 'Az adatkérési forgatókönyv jelenleg nem támogatott.',
	'preAggregateLabel': 'Adatkérési értékek alkalmazása az adatforrásból',
	'postAggregateLabel': 'A jelentésben lévő adatkérési értékek alkalmazása',
	'preAggregateText': 'A tartomány az adatforrásban szereplő értékeket használja, nem a műszerfalon megjelenített értékeket.',
	'defaultAggregation_count': 'Darabszám',
	'defaultAggregation_countdistinct': 'Egyedi darabszám',
	'defaultAggregation_max': 'Maximális',
	'defaultAggregation_min': 'Minimális',
	'defaultAggregation_avg': 'Átlag',
	'defaultAggregation_sum': 'Összeg',
	'defaultAggregation_auto': 'Automatikus (%{aggregationType})',
	'keydriver_average': 'Teljes átlag',
	'keydriver_up_down': 'A kiemelt csoportok magas vagy alacsony átlagaikkal nagyobb hatást gyakorolnak a célra. A szokatlanul magas vagy alacsony átlagú csoportok gyakorolják a legerősebb hatást.',
	'keydriver_different': 'A kiemelt csoportok eloszlása jelentősen különbözik a teljes eloszlástól. Ezek a csoportok erősebb hatással vannak a célra.',
	'topOperator': 'Felső',
	'bottomOperator': 'Alsó',
	'topBottomFact': '%{operator} %{value}%{percent}, %{columnLabel} szerint',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Az első vagy az utolsó elemek számának törlése',
	'deleteTopBottomPercent': 'Az első vagy az utolsó elemek százalékának törlése',
	'topBottomTitle': 'Csak ez az objektum',
	'deleteTopBottom': 'Az első vagy az utolsó elemek számának törlése',
	'editTopBottom': 'Az első vagy az utolsó elemek számának szerkesztése',
	'editTopBottomCount': 'Az első vagy az utolsó elemek számának szerkesztése',
	'editTopBottomPercent': 'Az első vagy az utolsó elemek százalékának szerkesztése',
	'ariaDeleteTopBottomCountLabel': 'Az első vagy az utolsó elemek számának törléséhez nyomja le a DELETE billentyűt.',
	'ariaDeleteTopBottomPercentLabel': 'Az első vagy az utolsó elemek százalékának törléséhez nyomja le a DELETE billentyűt.',
	'ariaEditTopBottomCountLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaEditTopBottomPercentLabel': 'Az első vagy az utolsó elemek százalékának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteDrillStateLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'drillUpStateTitle': 'Felfúrás',
	'drillDownStateTitle': 'Lefúrás',
	'ariaEditTopBottomLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteTopBottomLabel': 'Az első vagy az utolsó elemek számának törléséhez nyomja le a DELETE billentyűt.',
	'allKeyDriversLabel': 'Automatikus (minden tényező)',
	'filter_drag_and_drop_single_dock': 'Húzza ide az adatokat a szűréshez.',
	'filter_drag_and_drop_all_tabs': 'Húzza ide az adatokat az összes lapon történő szűréshez.',
	'filter_drag_and_drop_current_tab': 'Húzza ide az adatokat az aktuális lapon történő szűréshez.',
	'filter_empty_consume_mode': 'Nincs alkalmazva szűrő.',
	'filterClearAllItems': 'Összes szűrő kiürítése',
	'filterDeleteAllItems': 'Összes szűrő törlése',
	'filterDockChevronLeft': 'Adatok görgetése',
	'filterDockChevronRight': 'Adatok görgetése',
	'filterIconLabel_Single': 'Szűrők',
	'filterIconLabel_Global': 'Minden lap',
	'filterIconLabel_Tab': 'Ez a lap',
	'filterIconTooltip_Single': 'Szűrők',
	'filterIconTooltip_Global': 'Összes lapra vonatkozó szűrők',
	'filterIconTooltip_Tab': 'Adott lapra vonatkozó szűrők',
	'filterDropZoneTooltip_Single': 'Szűrő lerakási zóna',
	'filterDropZoneTooltip_Global': 'Összes lapra vonatkozó szűrő lerakási zóna',
	'filterDropZoneTooltip_Tab': 'Adott lapra vonatkozó szűrő lerakási zóna',
	'filterOverflowMenu': 'Továbbiak',
	'expand': 'Kibontás',
	'collapse': 'Visszazárás',
	'filterDockItemNameAriaLabel': 'Nyomja le az Entert a szűrő párbeszédablak elindításához, és adja meg a szűrést.',
	'filterItemCanvasMove': 'Hozzáadás a vászonhoz',
	'filterItemDelete': 'Szűrő törlése',
	'filterInvertRange': 'minden, a következők kivételével: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Nem %{from} után',
	'filter_date_after': '%{from} után',
	'filter_date_before_except': 'Nem %{to} előtt',
	'filter_date_before': '%{to} előtt',
	'filter_date_between_except': 'Nem %{from} és %{to} között',
	'filter_date_between': '%{from} és %{to} között',
	'filterValueSeparator': ',',
	'filterAll': 'Mind',
	'filter': 'Szűrő',
	'filterExcept': 'Kivéve: %{values}',
	'filterDockToolbarButtonLabel': 'Szűrődokk',
	'navigateTitle': 'Navigálás ide:',
	'navigateSelectColumn': 'Oszlop kiválasztása',
	'navigateSelectPath': 'Navigációs útvonal kiválasztása',
	'current_nav_group': 'Az aktuális navigációs csoport: %{navigation_group_name}',
	'next': 'Tovább',
	'previous': 'Előző',
	'multiselectMsg': '%{count} kiválasztva',
	'errMsgFilterItemMissingTitle': 'A(z) %{itemName} szűrőérték(ek) nem tölthető(k) be, mert az adathalmazhoz nem állnak rendelkezésre ezek az értékek',
	'errMsgFilterItemGenericTitle': 'A szűrőértékek nem tölthetők be',
	'textFilterItemsNotFound': 'Nincs elérhető elem.',
	'nullValueLabel': '(üres)',
	'filterConditionLabel': 'Szűrési feltétel',
	'filter_includesAll': 'Összes tartalmazása',
	'filter_allMembersOfSet': 'A halmaz összes tagja',
	'modelFilter': 'Szűrő',
	'filtersTitle': 'Szűrő tulajdonságok',
	'search': 'Keresés',
	'clearTextFilterValue': 'Törlés',
	'invertFilterSelection': 'Megfordítás',
	'modellingLoading': 'Betöltés...',
	'searchAll': 'Összes oszlop megkeresése',
	'toolbarActionPossibleKeyDrivers': 'Hatókör szerkesztése',
	'toolbarActionPossibleKeyDriversSubTitle': 'A tényezőelemzés diagramon történő figyelembevételhez húzzon ide elemeket a bal oldalról',
	'toolbarActionSort': 'Rendezés',
	'toolbarActionSortAscending': 'Növekvő',
	'toolbarActionSortDescending': 'Csökkenő',
	'toolbarActionSortAuto': 'Automatikus (%{sortOrder})',
	'toolbarActionSortCustom': 'Egyéni',
	'toolbarActionFormat': 'Adatok formázása',
	'toolbarActionFormatText': 'Adatok formázása (szöveg)',
	'toolbarActionFormatAbbreviation': 'Rövidítés',
	'toolbarActionFormatNone': 'Automatikus',
	'toolbarActionFilter': 'Szűrő',
	'toolbarActionTopBottom': 'Felső vagy alsó',
	'toolbarActionRmvShape': 'Alakzat eltávolítása',
	'toolbarActionToggleShapeDrop': 'Infografika alakja',
	'toolbarActionToggleShapeDropTitle': 'Infografika létrehozása',
	'toolbarActionToggleShapeDropText': 'Húzzon egy alakot erre a mezőre az infografika létrehozásához.',
	'toolbarActionAggregationType': 'Összegzés',
	'toolbarDeleteActionText': 'Oszlop eltávolítása',
	'toolbarTextActionText': 'Stílus szövege',
	'toolbarActionFilterLocalKeepSelected': 'Megtartás',
	'toolbarActionFilterLocalExcludeSelected': 'Kizárás',
	'toolbarActionFilterAllKeepSelected': 'Szűrő',
	'toolbarActionSimpleCalculation': 'Egyszerű számítás',
	'toolbarActionDrillBack': 'Vissza',
	'toolbarActionDrillUp': 'Felfúrás',
	'toolbarActionDrillDown': 'Lefúrás',
	'toolbarActionJumpTo': 'Teljes körű átfúrás',
	'toolbarActionNavigate': 'Navigálás',
	'toolbarActionCreateFilterGroup': 'Új kapcsolat létrehozása',
	'toolbarActionDisconnectFilterGroup': 'Összes hivatkozás megszüntetése',
	'toolbarActionLinkFilterGroup': 'Hozzáadás meglévő kapcsolathoz',
	'toolbarActionLassoSelect': 'Eszköz kiválasztása',
	'toolbarActionRefreshDeveloperWidget': 'Frissítés',
	'textFontFamilySubClassHairline': 'Hajszálvonal',
	'textFontFamilySubClassThin': 'Vékony',
	'textFontFamilySubClassThinItalic': 'Vékony dőlt',
	'textFontFamilySubClassExtraLight': 'Extra könnyű',
	'textFontFamilySubClassExtraLightItalic': 'Extra könnyű dőlt',
	'textFontFamilySubClassLight': 'Egyszerű',
	'textFontFamilySubClassLightItalic': 'Könnyű dőlt',
	'textFontFamilySubClassRegular': 'Normál',
	'textFontFamilySubClassRegularItalic': 'Normál dőlt',
	'textFontFamilySubClassItalic': 'Dőlt',
	'textFontFamilySubClassMedium': 'Közepes',
	'textFontFamilySubClassMediumItalic': 'Közepes dőlt',
	'textFontFamilySubClassHeavy': 'Nehéz',
	'textFontFamilySubClassHeavyItalic': 'Nehéz dőlt',
	'textFontFamilySubClassDemiBold': 'Középkövér',
	'textFontFamilySubClassDemiBoldItalic': 'Középkövér dőlt',
	'textFontFamilySubClassBold': 'Félkövér',
	'textFontFamilySubClassBoldItalic': 'Kövér dőlt',
	'textFontFamilySubClassExtraBold': 'Extra kövér',
	'textFontFamilySubClassExtraBoldItalic': 'Extra kövér dőlt',
	'textFontFamilySubClassBlack': 'Fekete',
	'textFontFamilySubClassBlackItalic': 'Fekete dőlt',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'növekvő',
	'dlg_descending': 'csökkenő',
	'dlg_custom': 'egyéni',
	'dlg_none': 'nincs',
	'dlg_hierarchy': 'hierarchia',
	'dlg_namedSet': 'nevesített készlet',
	'dlg_rank': 'rank',
	'visualizationLabel': 'Megjelenítés',
	'chartLabel': '%{chartName} diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Az eszközelemen belüli navigáláshoz nyomja le az F12 billentyűt',
	'f10KeyDescription': 'Az eszközelem fókusznézetének indításához nyomja le az F10 billentyűt',
	'playButtonLabel': 'Lejátszás',
	'dataPlayerValueListLabel': 'Adatlejátszó értékei',
	'localFilterTitle': 'Csak ez az objektum',
	'globalFilterTitle': 'Minden objektum',
	'deleteFilter': 'Szűrő törlése',
	'editFilter': 'Szűrő szerkesztése',
	'ariaEditFilterLabel': 'A szűrő szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteFilterLabel': 'A szűrő törléséhez nyomja le a DELETE billentyűt.',
	'measureFilterBetween': '%{lowerBound} és %{upperBound} között',
	'measureFilterNotBetween': 'Nem %{lowerBound} és %{upperBound} között',
	'dimFilterIn': 'Tartalmazza a következőt: %{in}',
	'dimFilterNotIn': 'Nem tartalmazza a következőt: %{out}',
	'gtFilter': '%{lowerBound} után',
	'ltFilter': '%{upperBound} előtt',
	'ariaEditPrompt': 'Az adatkérési érték megváltoztatásához nyomja le az ENTER billentyűt.',
	'dataPointFilterTitle': 'Adatpontok',
	'dataPointFilterIncludeSummary': '%{valueCount} adatpontot tartalmaz',
	'dataPointFilterExcludeSummary': '%{valueCount} adatpontot kizár',
	'widgetFiltersLabel': 'Eszközelemszűrők',
	'coachMarkTitleSpiralTarget': 'Hatókör szerkesztése',
	'coachMarkContentSpiralTarget': 'Itt érheti el és módosíthatja a célhoz kijelölt tényezőket.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Ismeretlen helyek:',
	'geomapAmbiguousLocations': 'Nem egyértelmű régiók',
	'visualizationNotifications': 'Megjelenítési értesítések:',
	'dataNotifications': 'Adatokra vonatkozó értesítések:',
	'autobinSuggestion': 'Automatikus csoportosítás bekapcsolása',
	'LIVE_empty_visualization_hint_title': 'Állítsa össze a megjelenítést',
	'LIVE_empty_visualization_hint_description': 'Húzza az adatokat ide vagy a mezőkre.',
	'LIVE_slots_required_field_description': '%{asterisk} kötelező mezőt jelöl',
	'LIVE_slots_drag_and_drop_description': 'Húzza az adatokat a fenti mezőkre a megjelenítés összeállításához és szűréséhez.',
	'dwErrorLoadingAvailableVisualizations': 'Az elérhető megjelenítési meghatározásokat nem lehet betölteni',
	'moreDataIndicator': 'Az adatok %{threshold} elem esetében kivágásra kerültek. Alkalmazzon szűrőt kevesebb elem megjelenítéséhez.',
	'nonCtxTopBottomInvalid': 'Felső vagy alsó szabály meghatározása kontextus nélkül a kereszttáblák esetében nem támogatott. Eltávolításra került a kereszttábla nézetből.  Finomítsa a szabályt egy vagy több kategóriában a(z) %{columnName} kontextusában.',
	'dwErrorLoadingVisualizationNotFound': 'Az objektumot nem lehet betölteni, mert hiányzik belőle egy megjelenítési meghatározás.',
	'dwErrorLoadingVisualizationListNotFound': 'A megjelenítést nem lehet betölteni.',
	'dwErrorRunningQuery': 'Az adatok lekérése nem sikerült a(z) %{datasetName} adathalmazból.',
	'dwErrorGeoData': 'Probléma merült fel a földrajzi adatok térképen történő megjelenítése során. Válasszon egy másik megjelenítési típust.',
	'dwPromptSignonCancelWarning': 'A megjelenítéshez tartozó adatok nem érhetők el. Adja meg a megfelelő hitelesítő adatokat.',
	'dwErrorMissingDataset': 'A megjelenítés nem tölthető be, mert a hozzárendelt "%{datasetName}" adathalmaz nem érhető el.',
	'dwErrorRenderingVisualization': 'Ezt a megjelenítést nem lehet betölteni.',
	'dwErrorVisualizationTooSmall': 'A megjelenítés túl kicsi, így nem jeleníthetők meg a benne lévő adatok. Nagyítsa a megjelenítést vagy korlátozza a benne tárolt adatokat.',
	'errorSourceNotFound': 'A megjelenítés nem tölthető be, mert a hozzárendelt "%{sourceName}" forrás nem érhető el.',
	'errorActionNotSupported': 'Ez a művelet nem támogatott "%{sourceName}" adatforrás esetén.',
	'errorMeasureNotSupportedOnMultiEdges': 'A megjelenítés több szélen tartalmaz mérőszámokat, ami már nem támogatott. Helyezze a mérőszámokat egyetlen szélre.',
	'errorExceedAllowableValue': 'A cellák becsült száma meghaladja a megengedett értéket (100000). A tervezett halmazokra szűrést alkalmazva csökkentse a cellák számát.',
	'propScaleLabel': 'Ikonok mennyisége',
	'propScaleDescription': 'Válassza ki az ikonok mennyiségét',
	'propScaleFew': 'Alsó',
	'propScaleDefault': 'Alapértelmezett',
	'propScaleMany': 'Felső',
	'lastRefresh': 'Utolsó frissítés: %{timeInterval} idővel ezelőtt',
	'widgetTimer': 'Eszközelem időmérője',
	'datasetItemsUnavailable': 'Az ebben a megjelenítésben használt egyes adathalmazelemek nem érhetők el.',
	'datasetItemUnavailable': 'Ez az adathalmazelem nem érhető el',
	'retry': 'Újra próbálkozás',
	'widgetConditionalFormatLabel': 'Feltételes formátum vezérlőinek váltása',
	'widgetConditionalFormatTitle': 'Feltételes formázás színének szerkesztése',
	'crosstabName': 'Kereszttábla',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'n.a.',
	'summaryLabel': '%{label} %{value} értékkel',
	'infographicLabel': '%{label} %{value} értékkel',
	'warning': 'Figyelmeztetés',
	'swapRowsAndColumns': 'Sorok és oszlopok felcserélése',
	'hideSummariesLabel': 'Összegzések elrejtése',
	'showSummariesLabel': 'Összegzések megjelenítése',
	'hideRowColumn': 'Elrejtés',
	'showAllRowColumn': 'Az összes megjelenítése',
	'dataAssetPropertiesLabel': 'Megjelenítési tulajdonságok',
	'evAdd': 'Oszlop hozzáadása',
	'evCollapse': 'Visszazárás',
	'evColumns': 'Oszlopok',
	'evLocalFilters': 'Helyi szűrők',
	'evExpand': 'Kibontás',
	'evFilterTooltip': 'Szűrő',
	'missingColumn': 'Hiányzik: %{columnLabel}',
	'missingFiltering': 'Hiányzó oszlopszűrők:',
	'missingDataItem': 'A hivatkozott "%{dataItemId}" adatelem nem található a felületi elemben.',
	'heatByLabel': 'Intenzitás e szerint:',
	'toolbarChangeVisualization': 'Megjelenítés módosítása',
	'modellingRelatedTablesNoneFound': 'Nincs kapcsolódó tábla',
	'processing': 'Feldolgozás...',
	'errorCellWarning': 'Néhány összegzett értéket nem sikerült kiszámítani.',
	'aggregateTypeToggler': 'Összesítési típus megjelenítése',
	'maxColumnsExceeded': 'Túllépte az oszlopok maximális számát. A(z) %{columns} eldobásra került.',
	'unboundColumns': 'A következő oszlopok nem használhatók: %{columns}.',
	'unboundColumn': 'A következő oszlop nem használható: %{columns}.',
	'recommendRequestFailed': 'Az ajánlás meghibásodik meghiúsult. Forduljon az adminisztrátorhoz.',
	'visualizationDoesNotSupportOLAP': 'Ezt az OLAP adatforráson alapuló megjelenítést nem tudjuk létrehozni. Használjon másik támogatott adatforrást.',
	'showDataBehindVizLabel': 'Adatok megjelenítése',
	'showDataBehindVizNotSupportedLabel': 'Az adatok megjelenítése ezen megjelenítési típus esetében nem támogatott',
	'exploreData': 'Böngészés ...',
	'newExplore': 'Új böngészés',
	'thumbnails_error_fetching': 'Hiba a miniatűrök lehívásakor',
	'loadedThumbnailImage': 'A(z) %{visType} megjelenítés miniatűr képét betöltötte a rendszer',
	'autobinAxisLabel': 'csoportok',
	'recommended_visualizations': 'Javasolt megjelenítések',
	'all_visualizations': 'Összes megjelenítés',
	'edit': 'Szerkesztés',
	'selectTargetDialogTitle': 'Átfúrási cél kiválasztása',
	'noTargetInCM': 'A teljes körű átfúrás célja nem található',
	'errorDrillDefinition': 'Valami hiba történt az átfúrásmeghatározás hozzáadása vagy szerkesztése során.',
	'errorDrillToTarget': 'Hiba történt a(z) "%{targetName}" felé történő lefúráskor.',
	'drillThroughMappingViewLabel': 'Oszlopok hozzárendelése a műszerfalról a cél jelentés adatbekérőihez',
	'drillthroughScopeRadioLabel': 'A meghatározás alkalmazása a következőre:',
	'drillthroughScopeRadioOptionVisualization': 'Csak ez a megjelenítés',
	'drillthroughScopeRadioOptionConnection': 'Ugyanazt az adatforrást használó kapcsolat megjelenítései',
	'drillthroughScopeRadioOptionDashboard': 'Bármely azonos adatforrást használó megjelenítés a(z) %{perspective} műszerfalon',
	'drillThroughParametersColumnTitle': '"%{targetName}" adatkérések:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" adatoszlopok:',
	'drillThroughDefinitionNoParameter': 'Az átfúrási célnak nincsenek adatbekérései.',
	'drillThroughDefinitionErrorQueryingReport': 'Javítsa ki a cél jelentés problémáját, majd próbálja újra létrehozni az átfúrásmeghatározást.',
	'drillThroughDefinitionErrorDlgTitle': 'Hiba történt',
	'dlg_back': 'Vissza',
	'dlg_close': 'Bezárás',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Mégse',
	'dlg_apply': 'Alkalmaz',
	'dlg_create': 'Létrehozás',
	'dlg_done': 'Kész',
	'drillthrough_unsaveMsg': 'Folytatja a(z) "%{name}" mentése nélkül?',
	'drillthrough_jumpTo': 'Átfúrásmeghatározás: %{name}',
	'drillthrough_jumpToLabel': 'Teljes körű átfúrás',
	'drillthrough_manage': 'Kezelés...',
	'drillthrough_addNewTarget': 'Új teljes körű átfúrásmeghatározás hozzáadása',
	'drillthrough_manageJumpPaths': 'Átfúrásmeghatározások kezelése',
	'drillthrough_manageJumpPaths_edit': '"%{name}" szerkesztése',
	'drillthrough_manageJumpPaths_delete': '"%{name}" törlése',
	'drillthrough_manageAddAnotherTarget': 'Másik átfúrásmeghatározás hozzáadása',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Törlés megerősítése',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Biztosan törli a(z) "%{name}" átfúrást?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplán szereplő átfúrásnév',
	'drillthrough_definitionMessage': 'A(z) "%{name}" átfúrás már létezik. Adjon meg egy másik nevet',
	'drillthrough_jumpToTarget_notFound': 'Nem található a cél a(z) "%{name}" átfúráshoz',
	'drillThroughDefinitionNoParameterSubTitle': 'Nem lesz átadva kontextus a céljelentésnek.',
	'drillthrough_titleLabel': 'Név',
	'drillthrough_create_dialogTitle': 'Átfúrásmeghatározás létrehozása',
	'drillthrough_edit_dialogTitle': 'Átfúrásmeghatározás szerkesztése',
	'drillthrough_subTitle': 'A forrás megjelenítési kontextusa a cél %{perspective} szűrésére szolgál.',
	'drillthrough_selectColumn': 'Oszlop kiválasztása',
	'noPrompt': 'Nincs adatbekérő',
	'promptDialog': '%{promptType} adatbekérő párbeszédablak',
	'formatAutoDescription': 'Az Auto az adatforrásból vagy megjelenítésből örökölt formátumot határozza meg.',
	'formatDefaultDescription': 'Az Alapértelmezett a rendszertől örökölt formátumot határozza meg',
	'createCustomGroupAction': 'Adatcsoport létrehozása',
	'removeCustomGroupAction': 'Adatcsoport eltávolítása',
	'editCustomGroupAction': 'Adatcsoport szerkesztése',
	'renameCustomGroupAction': 'Adatcsoport átnevezése',
	'createCustomGroupErrorToast': 'Az adatcsoport nem hozható létre.',
	'removeCustomGroupErrorToast': 'Az adatcsoport nem távolítható el.',
	'editCustomGroupErrorToast': 'Az adatcsoport nem szerkeszthető.',
	'renameCustomGroupErrorToast': 'Az adatcsoport nem átnevezhető.',
	'customGroupLabel': 'Adatcsoport létrehozása',
	'ungroupCustomGroupLabel': 'Csoportbontás',
	'renameCustomGroupLabel': 'Átnevezés',
	'createCustomGroupLabel': 'Létrehozás',
	'customGroupingLabel': '%{columnLabel} (Csoport)',
	'createCustomSort': 'Egyéni rendezés létrehozása',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Válassza ki a rendelkezésre álló elemeket, majd egyéni rendezéssel rendezze újra őket.',
	'availableItems': 'Rendelkezésre álló elemek',
	'selectAll': 'Összes kijelölése',
	'customSortOrder': 'Egyéni rendezési sorrend',
	'selectAvailableItemsDesc': 'Válassza ki a rendelkezésre álló elemeket, majd itt rendezze újra őket.',
	'moveToTop': 'Áthelyezés felülre',
	'clear': 'Törlés',
	'sortRemainingItemsBy': 'Fennmaradó elemek rendezési szempontja',
	'removeAll': 'Összes eltávolítása',
	'resetTooltip': 'A(z) %{customSortOrder} listából minden elem eltávolításra kerül. És a(z) %{sortRemainingItemsBy} legördülő lista neve visszaáll az alapértelmezettre.',
	'manyItemsWarning': 'Sok elem kijelölése hatással lehet műszerfala teljesítményére.',
	'manyItemsSelected': 'Több, mint %{maxItems} elem van kijelölve, ez hatással lehet a műszerfal teljesítményére.',
	'somethingWentWrong': 'Ajjaj. Valami nincs teljesen rendben. ',
	'tryAgain': 'Ismételt próbálkozás',
	'customSortLabel': 'Egyéni rendezés',
	'applyError': 'A(z) %{action} nem alkalmazható.',
	'searchReturnedNoResults': 'Hmm, a keresés nem hozott eredményt.',
	'extVisSystem': 'Rendszer',
	'extVisCustom': 'Egyéni',
	'customVisTestVisualization': 'Megjelenítés tesztelése',
	'extVisCustomVisPreview': 'előnézet',
	'extVisCustomPreviewWidgets': 'Fejlesztői felületi elemek',
	'extVisCustomVVisualization': 'Megjelenítés',
	'extVisCustomVisuals': 'Egyéni megjelenítések',
	'noPermissionToManage': 'Nem jogosult egyéni megjelenítések kezelésére.',
	'extVisCustomUpdate': 'Frissítés',
	'extVisCustomDelete': 'Törlés',
	'extVisNoCustomVisuals': 'Nincsenek egyéni vizuális elemek',
	'extVisNoCustomVisualsMsg': 'Szervezeténél jelenleg nincsenek egyéni képek',
	'extVisAddCustomVisual': 'Egyéni vizuális elem hozzáadása',
	'extVisNoCustomVisualsAdminMsg': 'Jelenleg nincsenek egyéni képek. A kezdéshez adjon hozzá egyet',
	'extVisNoSDKConnection': 'Nem jött létre kapcsolat a helyi fájlhoz',
	'extVisNoSDKPreviewMsg': 'A megjelenítések előnézetéhez hozzon létre kapcsolatot.',
	'extVisMore': 'Továbbiak',
	'extVisDeleteDialogTitle': 'Egyéni kép törlése',
	'extVisDeleteDialogBody': 'Biztosan törli ezt az egyéni megjelenítést? Lehet, hogy más műszerfalak vagy jelentések még használják.',
	'extVisDeleteConfirmation': 'Az egyéni vizuális elem törlésre került.',
	'extVisDeleteError': 'Az egyéni vizuális elem nem törölhető. %{msg}',
	'extVisCloseToast': 'Bezárás most',
	'extVisAdd': 'Az egyéni vizuális elem sikeresen hozzáadásra került.',
	'extVisAddError': 'Az egyéni vizuális elem nem adható hozzá. %{msg}',
	'extVisUpdate': 'Az egyéni vizuális elem sikeresen frissítésre került.',
	'extVisUpdateError': 'Az egyéni vizuális elem nem frissíthető. %{msg}',
	'extVisAddProgress': '%{name} importálása',
	'extVisUpdateProgress': '%{name} frissítése',
	'extPermissionTitle': 'Korlátozott hozzáférés vagy törölt egyéni vizuális elem',
	'extPermissionBody': 'Ez az egyéni vizuális elem nem jeleníthető meg, mert vagy törölt, vagy korlátozott hozzáféréssel rendelkezik.',
	'customVizSaveWarning': 'Az egyéni vizuális elemeket nem  lehet menteni. Nem lettek importálva.',
	'schematicTestCaption': 'Tervrajz tesztelése',
	'schematicServiceRequestError': 'Tervrajzszolgáltatás hiba',
	'extVisPreviewMessage': 'Ez egy előkép. A megjelenítés még nem lett hozzáadva a termékhez.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Meghatározatlan',
	'kpiDefaultTargetLabel': 'Cél',
	'kpiNonNumericTarget': 'A cél értéke csak szám lehet.',
	'kpiManualTargetSlotFilled': 'A mezőben alkalmazott érték',
	'kpiAutoValueSize': 'Automatikus',
	'kpiUnableDrawSparklineLabel': 'Nem lehet értékgörbét rajzolni',
	'kpiUnableDrawSparklineInfo': 'Az értékgörbéhez legalább két időbeli pontra van szükség. Az értékgörbe megtekintéséhez módosítsa az adatokat vagy állítsa be a szűrőket.',
	'conditionalFormattingTextColor': 'Szöveg színe',
	'suppression': 'Elnyomás',
	'suppressNone': 'Nincs',
	'suppressRowsAndColumns': 'Sorok és oszlopok.',
	'suppressRows': 'Sorok',
	'suppressColumns': 'Oszlopok',
	'enableSuppression': 'Elnyomás engedélyezése',
	'disableSuppression': 'Elnyomása letiltása',
	'loadVisDefinitionError': 'A(z) %{id} megjelenítés meghatározása nem tölthető be',
	'emptyVisualization': 'Üres megjelenítés',
	'expandCollapse': 'Kibontás és összehúzás',
	'expandBtnLabel': 'Kibontás',
	'collapseBtnLabel': 'Visszazárás',
	'prop_sizeInputNonNumericValue': 'Az értéknek számnak kell lennie.',
	'prop_sizeValueShouldBeHigher': 'Az értéknek nagyobbnak kell lennie, mint %{value}.',
	'fontPropLabel': 'Betűtípuscsalád',
	'fontSizePropLabel': 'Betűméret',
	'sectionItemAxisTitle': 'Elem tengelycíme',
	'sectionItemAxisLabel': 'Elem tengelycímkéje',
	'sectionValueAxisTitle': 'Értéktengely címe',
	'sectionValueAxisLabel': 'Értéktengely címkéje',
	'styletext-widget.legend': 'Jelmagyarázat',
	'styletext-itemAxis.ticks.labels': 'Tengelyfeliratok',
	'styletext-valueAxis.title': 'Tengelycímek',
	'styletext-itemAxis.title': 'Tengelycímek',
	'styletext-labels': 'Adatcímkék',
	'styletext-valueAxis.line.title': 'Sorcímek',
	'styletext-cellValue': 'Értékek',
	'styletext-values': 'Értékek',
	'styletext-rowHeading': 'Sorfejlécek',
	'styletext-columnHeading': 'Oszlopfejlécek',
	'fontFamily': 'család',
	'fontSize': 'méret',
	'visExportFileName': 'Megjelenítés',
	'ds-missingDataSet': 'Nem található az adathalmaz. Győződjön meg róla, hogy az adathalmaz létrehozása sikeresen létrejött.',
	'ds-missingDashboardId': 'Az adathalmaz létrehozása előtt mentse a műszerfalat.',
	'ds-unsupportedDataSourceType': 'A(z) %{type} adatforrás típusa nem támogatott.',
	'dataCache': 'Adatgyorsítótár',
	'dataCache_on': 'Be',
	'dataCache_off': 'Nincs gyorsítótár',
	'dataCache_auto': 'Automatikus',
	'queryOptimization': 'Lekérdezés optimalizálás'
});
